import React from 'react'
import { LayoutBand, colors, Row } from '@fs/zion-ui'
import { Person } from '@fs/zion-person'
import type { Person as PersonType } from '@fs/zion-tree-types'
import { css } from '@emotion/core'
import { useTranslation } from 'react-i18next'
import { useParams } from '@fs/zion-router'
import ErrorBoundary from '@fs/zion-error-boundary'
import BannerActions from './BannerActions'
import PortraitSelectorButton from './PortraitSelectorButton'
import ColorStripe from './ColorStripe'

const alignCss = css`
  /* Start margin to line up the actions with the person details above it */
  margin-inline-start: 108px;
`

type Props = {
  focusPerson: PersonType | undefined
}
export default function PersonBanner({ focusPerson }: Props): JSX.Element {
  const [t] = useTranslation()
  const { pid } = useParams()

  return (
    <ErrorBoundary>
      <h1
        style={{
          /* Removes horizontal scrollbar. See https://familysearch.slack.com/archives/CMLL2NGUF/p1680197930194719 */
          overflow: 'hidden',
        }}
      >
        <ColorStripe gender={focusPerson?.gender} />

        <LayoutBand maxWidth="lg" color={colors.gray00} marginY="nano" marginX="nano">
          <Row alignY="middle">
            {/* eslint-disable-next-line test-selectors/button -- NA */}
            <PortraitSelectorButton noShrinkX focusPerson={focusPerson} size="lg" />
            <Person
              hideAvatar
              personObj={
                focusPerson || {
                  name: t('tree-person.unknown.label'),
                  id: pid,
                  unknown: true,
                }
              }
              componentSize="xl"
              lifespanSize="long"
              doNotLinkToPersonPage
            />
          </Row>
          {focusPerson && (
            <div css={alignCss}>
              <BannerActions focusPerson={focusPerson} />
            </div>
          )}
        </LayoutBand>
      </h1>
    </ErrorBoundary>
  )
}
